export const PROMO_BANNER_PREF_KEY = 'redevicer_promo_banner_enabled'
export const PROMO_BANNER_PREF_EVENT = 'redevicer:promo-banner-pref'

export function isPromoBannerEnabled(): boolean {
  try {
    return localStorage.getItem(PROMO_BANNER_PREF_KEY) !== '0'
  } catch {
    return true
  }
}

export function setPromoBannerEnabled(enabled: boolean): void {
  try {
    localStorage.setItem(PROMO_BANNER_PREF_KEY, enabled ? '1' : '0')
  } catch {
    /* ignore */
  }
  window.dispatchEvent(new CustomEvent(PROMO_BANNER_PREF_EVENT, { detail: { enabled } }))
}
